import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface ActivityBarProps {
  onNavigateBack?: () => void
  // Future: Add more activity buttons here
}

export default function ActivityBar({ onNavigateBack }: ActivityBarProps) {
  const navigate = useNavigate()

  return (
    <div className="w-12 flex flex-col items-center border-r bg-muted/30 flex-shrink-0">
      <Button
        variant="ghost"
        size="icon"
        onClick={() => onNavigateBack ? onNavigateBack() : navigate('/scripts')}
        className="h-10 w-10 rounded-none"
        title="Back to Scripts"
      >
        <ArrowLeft className="w-4 h-4" />
      </Button>
      <div className="flex-1" />
    </div>
  )
}
